import { createSelector } from 'reselect';

import { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import { RECOMMENDATION_ENGINES } from '@/domains/productDiscovery/Recommendation/constants';

const recoBaseSelector = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
) => state?.productDiscovery?.productRecommendation;

export const recommendationConfigSelector = createSelector(
  [
    recoBaseSelector,
    (
      recoBaseSelector: Partial<SpartacuxProductDiscoveryDomainState>,
      recoEngineName: RECOMMENDATION_ENGINES,
    ) => recoEngineName,
  ],
  (state, recoEngineName) =>
    state?.recommendationsConfig?.find(
      (config) => config.engineName === recoEngineName,
    ),
);

export const recommendationSelector = createSelector(
  [
    recoBaseSelector,
    (
      recoBaseSelector: Partial<SpartacuxProductDiscoveryDomainState>,
      recoEngineName: RECOMMENDATION_ENGINES,
    ) => recoEngineName,
  ],
  (state, recoEngineName) =>
    state?.recommendations?.find(
      (recommendations) => recommendations.engineName === recoEngineName,
    ),
);

export const isFetching = createSelector(
  [recoBaseSelector],
  (recoBaseSelector) => recoBaseSelector?.fetching,
);

export const hasError = createSelector(
  [recoBaseSelector],
  (recoBaseSelector) => recoBaseSelector?.error,
);
